import React, { Component } from 'react';
import { getShuffledTagColors } from '../../util';
import './aiTags.scss';
import AiTag from './components/aiTag/aiTag';

interface IAiTagsProps {
    tags: string[];
}

export default class AiTags extends Component<IAiTagsProps, {}> {
    public shouldComponentUpdate(nextProps: IAiTagsProps) {
        return JSON.stringify(nextProps) !== JSON.stringify(this.props);
    }
    public renderTags() {
        const props = this.props;
        const colors = getShuffledTagColors();
        return props.tags.map((tag: string, index: number) => {
            return <AiTag key={index} tag={tag} color={colors[index]} />;
        });
    }

    public render() {
        return <div className="ai-tags">{this.renderTags()}</div>;
    }
}
